"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlliancesSearchFilterDTO = exports.GetUserPendingsDTO = exports.GetAlliancePendingsDTO = exports.KickMemberDTO = exports.UpdateApplicationDTO = exports.InviteUserDTO = exports.JoinAllianceDTO = exports.DisbandAllianceDTO = exports.UpdateAllianceDTO = exports.CreateAllianceDTO = exports.GetAllianceDTO = exports.AllianceListDTO = exports.LeaderBoardDTO = exports.AllianceRankDTO = exports.AlliancePendingListDTO = exports.AlliancePendingDTO = exports.AllianceDTO = exports.AllianceLightDTO = exports.AllianceOrderEnum = exports.CountryCodes = exports.AllianceRoles = exports.PendingStatuses = exports.RanksTypes = exports.InvitePolicies = void 0;
const class_validator_1 = require("class-validator");
const Pagination_1 = require("./Pagination");
var InvitePolicies;
(function (InvitePolicies) {
    InvitePolicies["Opened"] = "Opened";
    InvitePolicies["Invite"] = "Invite";
    InvitePolicies["Closed"] = "Closed";
})(InvitePolicies = exports.InvitePolicies || (exports.InvitePolicies = {}));
var RanksTypes;
(function (RanksTypes) {
    RanksTypes["Global"] = "Global";
    RanksTypes["National"] = "National";
    RanksTypes["Regional"] = "Regional";
})(RanksTypes = exports.RanksTypes || (exports.RanksTypes = {}));
var PendingStatuses;
(function (PendingStatuses) {
    PendingStatuses["Invited"] = "Invited";
    PendingStatuses["Applicant"] = "Applicant";
})(PendingStatuses = exports.PendingStatuses || (exports.PendingStatuses = {}));
var AllianceRoles;
(function (AllianceRoles) {
    AllianceRoles["Admin"] = "Admin";
    AllianceRoles["Moderator"] = "Moderator";
    AllianceRoles["Member"] = "Member";
})(AllianceRoles = exports.AllianceRoles || (exports.AllianceRoles = {}));
var CountryCodes;
(function (CountryCodes) {
    CountryCodes["FR"] = "FR";
    CountryCodes["RU"] = "RU";
    CountryCodes["US"] = "US";
    CountryCodes["UK"] = "UK";
    CountryCodes["ES"] = "ES";
    CountryCodes["DE"] = "DE";
    CountryCodes["IT"] = "IT";
})(CountryCodes = exports.CountryCodes || (exports.CountryCodes = {}));
var AllianceOrderEnum;
(function (AllianceOrderEnum) {
    AllianceOrderEnum["createDate"] = "createDate";
    AllianceOrderEnum["globalRank"] = "globalRank";
})(AllianceOrderEnum = exports.AllianceOrderEnum || (exports.AllianceOrderEnum = {}));
class AllianceLightDTO {
}
exports.AllianceLightDTO = AllianceLightDTO;
class AllianceDTO extends AllianceLightDTO {
}
exports.AllianceDTO = AllianceDTO;
class AlliancePendingDTO {
}
exports.AlliancePendingDTO = AlliancePendingDTO;
class AlliancePendingListDTO {
}
exports.AlliancePendingListDTO = AlliancePendingListDTO;
class AllianceRankDTO {
}
exports.AllianceRankDTO = AllianceRankDTO;
class LeaderBoardDTO {
}
exports.LeaderBoardDTO = LeaderBoardDTO;
class AllianceListDTO {
}
exports.AllianceListDTO = AllianceListDTO;
let GetAllianceDTO = (() => {
    class GetAllianceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetAllianceDTO.prototype, "id", void 0);
    return GetAllianceDTO;
})();
exports.GetAllianceDTO = GetAllianceDTO;
let CreateAllianceDTO = (() => {
    class CreateAllianceDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(3),
        class_validator_1.MaxLength(15),
        __metadata("design:type", String)
    ], CreateAllianceDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsEnum(CountryCodes),
        __metadata("design:type", String)
    ], CreateAllianceDTO.prototype, "countryCode", void 0);
    __decorate([
        class_validator_1.IsEnum(InvitePolicies),
        __metadata("design:type", String)
    ], CreateAllianceDTO.prototype, "invitePolicy", void 0);
    return CreateAllianceDTO;
})();
exports.CreateAllianceDTO = CreateAllianceDTO;
let UpdateAllianceDTO = (() => {
    class UpdateAllianceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateAllianceDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateAllianceDTO.prototype, "leaderId", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(3),
        class_validator_1.MaxLength(15),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateAllianceDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsEnum(CountryCodes),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateAllianceDTO.prototype, "countryCode", void 0);
    __decorate([
        class_validator_1.IsEnum(InvitePolicies),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateAllianceDTO.prototype, "invitePolicy", void 0);
    return UpdateAllianceDTO;
})();
exports.UpdateAllianceDTO = UpdateAllianceDTO;
let DisbandAllianceDTO = (() => {
    class DisbandAllianceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], DisbandAllianceDTO.prototype, "allianceId", void 0);
    return DisbandAllianceDTO;
})();
exports.DisbandAllianceDTO = DisbandAllianceDTO;
let JoinAllianceDTO = (() => {
    class JoinAllianceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], JoinAllianceDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], JoinAllianceDTO.prototype, "userId", void 0);
    return JoinAllianceDTO;
})();
exports.JoinAllianceDTO = JoinAllianceDTO;
let InviteUserDTO = (() => {
    class InviteUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], InviteUserDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], InviteUserDTO.prototype, "invitedUserId", void 0);
    return InviteUserDTO;
})();
exports.InviteUserDTO = InviteUserDTO;
let UpdateApplicationDTO = (() => {
    class UpdateApplicationDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateApplicationDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateApplicationDTO.prototype, "applicantId", void 0);
    return UpdateApplicationDTO;
})();
exports.UpdateApplicationDTO = UpdateApplicationDTO;
let KickMemberDTO = (() => {
    class KickMemberDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], KickMemberDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], KickMemberDTO.prototype, "memberId", void 0);
    return KickMemberDTO;
})();
exports.KickMemberDTO = KickMemberDTO;
let GetAlliancePendingsDTO = (() => {
    class GetAlliancePendingsDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetAlliancePendingsDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsEnum(PendingStatuses),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], GetAlliancePendingsDTO.prototype, "status", void 0);
    return GetAlliancePendingsDTO;
})();
exports.GetAlliancePendingsDTO = GetAlliancePendingsDTO;
let GetUserPendingsDTO = (() => {
    class GetUserPendingsDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetUserPendingsDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsEnum(PendingStatuses),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], GetUserPendingsDTO.prototype, "status", void 0);
    return GetUserPendingsDTO;
})();
exports.GetUserPendingsDTO = GetUserPendingsDTO;
let AlliancesSearchFilterDTO = (() => {
    class AlliancesSearchFilterDTO extends Pagination_1.PaginationRequest {
    }
    __decorate([
        Pagination_1.CompatibleOrdering(AllianceOrderEnum),
        __metadata("design:type", Object)
    ], AlliancesSearchFilterDTO.prototype, "order", void 0);
    __decorate([
        class_validator_1.IsEnum(CountryCodes),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], AlliancesSearchFilterDTO.prototype, "countryCode", void 0);
    __decorate([
        class_validator_1.IsEnum(InvitePolicies),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], AlliancesSearchFilterDTO.prototype, "invitePolicy", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], AlliancesSearchFilterDTO.prototype, "query", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], AlliancesSearchFilterDTO.prototype, "lightDTO", void 0);
    return AlliancesSearchFilterDTO;
})();
exports.AlliancesSearchFilterDTO = AlliancesSearchFilterDTO;
//# sourceMappingURL=Alliance.js.map